'use client';

import { AppImageData } from '@components/appImage';
import { Carousel } from '@components/carousel';
import React from 'react';

import { ArticleCard } from '../../articleCard';

export interface CarouselCustomProps {
  id?: string;
  title?: string;
  articlesCards: {
    chips: string[];
    img: string;
    /** Данные AppImage из `getAppImageData`. Приоритетнее `img`. */
    imageData?: AppImageData;
    alt: string;
    label: string;
    tags: string[];
    urlArticle?: string;
    width: number;
    height: number;
  }[];
}
// comment
export const CarouselCustom = ({
  id = 'howSolutionsHeader',
  title = 'Как решения 2ГИС помогают нашим клиентам',
  articlesCards,
}: CarouselCustomProps) => {
  return (
    <>
      <h3
        id={id}
        className="mb-12 text-[2.75rem] leading-[52px] font-medium tracking-[-0.01em] max-md:text-[32px] max-md:leading-[38px]"
      >
        {title}
      </h3>
      {articlesCards.length > 3 && (
        <Carousel variant="mini" loop spaceBetweenSlides={32} countSlider={3}>
          {articlesCards.map((slider, index) => (
            <Carousel.Item key={index}>
              <div
                className={'mr-0 ml-0 flex h-full items-center justify-stretch'}
              >
                <ArticleCard {...slider} variant="article" />
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      )}

      {articlesCards.length <= 3 && (
        <div className="hidden grid-cols-3 gap-8 md:grid">
          {articlesCards.map((slider, index) => (
            <div
              key={index}
              className={'mr-0 ml-0 flex h-full items-center justify-stretch'}
            >
              <ArticleCard {...slider} variant="article" />
            </div>
          ))}
        </div>
      )}

      <div className="flex items-center gap-7 max-sm:flex-col max-sm:gap-6 md:hidden">
        {articlesCards.map((slider, index) => (
          <div
            key={index}
            className={
              'mr-0 ml-0 flex h-fit w-full flex-col items-center justify-center hover:cursor-pointer hover:bg-linear-to-b'
            }
          >
            <ArticleCard {...slider} variant="article" />
          </div>
        ))}
      </div>
    </>
  );
};
